import fetch from '@/utils/fetch';

export function getGmTree(params){

     return fetch({

         url: '/Service/Api/jd?service=ManageRuleService&method=getOrganizationAndPostTree&param=BaseParameter',
         method:"post",
         data:params

     })

}

export function getRoleList(params){

     return fetch({

         url: '/Service/Api/jd?service=ManageRuleService&method=getOrganizationAndPostList&param=GetOrganizationAndPostListParam',
         method:"post",
         data:params

     })

}

export function getConfiged(params){

     return fetch({

         url: 'ManageRule/ManageRule/getPostRuleTree',
         method:"post",
         data:params

     })

}

export function CreateRole(params){

     return fetch({

         url: 'ManageRule/ManageRule/addOrUdatePost',
         method:"post",
         data:params

     })

}

export function removeRole(params){

     return fetch({

         url: 'ManageRule/ManageRule/delOrganizationAndPost',
         method:"post",
         data:params

     })

}


export function ropSave(params){     //  角色权限

     return fetch({
         url: 'ManageRule/ManageRule/savePostRule',
         method:"post",
         data:params

     })

}


export function ropList(params){     //  角色权限

     return fetch({
         url: 'Rule/Rule/getPostRuleTree',
         method:"post",
         data:params

     })

}

export function dfPower(params){   //  获取职位默认权限

     return fetch({

         url: 'Rule/Rule/getUserPostRuleTree',
         method:"post",
         data:params

     })

}


export function getAllList(params){

    return fetch({

        url: '/Service/Api/jd?service=ManageRuleService&method=getAllList&param=GetAllListParam',
        method:"post",
        data:params

    })

}

export function getOrganizationTree(params){

    return fetch({

        url: '/Service/Api/jd?service=ManageRuleService&method=getOrganizationAndPostTree&param=BaseParameter',
        method:"post",
        data:params

    })

}

export function editManagePostDTO(params){

    return fetch({

        url: '/Service/Api/jd?service=ManageRuleService&method=editManagePostDTO&param=CommonIdParam',
        method:"post",
        data:params

    })

}

export function saveManagePostDTO(params){

    return fetch({

        url: '/Service/Api/jd?service=ManageRuleService&method=saveManagePostDTO&param=SaveManagePostDTOParam',
        method:"post",
        data:params

    })

}
export function deleteManagePostDTO(params){

    return fetch({

        url: '/Service/Api/jd?service=ManageRuleService&method=deleteManagePostDTO&param=CommonIdParam',
        method:"post",
        data:params

    })

}






// WEBPACK FOOTER //
// ./src/api/pgMent/roleMent.js